import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    // 423 = backend's blockUntilPasswordChanged: this session owes a password
    // change. The session is still valid, so keep the token and send the user to
    // the one screen that can clear it.
    if (error.response?.status === 423 && window.location.pathname !== '/change-password') {
      window.location.href = '/change-password';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),

  verifyLoginOtp: (userId: string, otp: string) =>
    api.post('/auth/login-verify-otp', { userId, otp }),

  switchCompany: (companyId: string) =>
    api.post('/auth/switch-company', { companyId }),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),

  verifyOTP: (email: string, otp: string, newPassword: string) =>
    api.post('/auth/verify-otp', { email, otp, newPassword }),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.post('/auth/change-password', { currentPassword, newPassword }),

  getProfile: () =>
    api.get('/auth/profile'),
};

export default api;
